import React from 'react'
import { Layout } from 'antd'
const { Footer: AntFooter } = Layout

const Footer = () => {
  return (
    <>
    </>
  )
}

export default Footer
